import axios from '../../../../utils/request';
function GET_LIST(params) {
    return axios.get("/kshAdmin/designer/index",{
        params: {
            page:params
        }
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/kshAdmin/designer/createPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.get("/kshAdmin/designer/edit",{
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/kshAdmin/ModuleCategory/create",{
        params: {
            ...params
        }
    } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/kshAdmin/designer/editPost",{...params} )
}
function LIST_ORDER(params) {
    return  axios.post("/kshAdmin/designer/listOrder",{list_orders:params} )
}
function DELE(params) {
    return  axios.post("/kshAdmin/designer/delete",{
            ids:params
    } )
}
function CHANG_STATUS_FILALE(params) {
    return  axios.post("/kshAdmin/designer/statusSwitch",{
        switch: {
            ...params
        }
    } )
}
export default {
    GET_LIST,
    SUBMIT_ADD,
    EDIT_DATA,
    ADD_DATA,
    SUBMIT_EDIT,
    LIST_ORDER,
    DELE,
    CHANG_STATUS_FILALE
};